import React, { forwardRef, useState } from 'react';
import { IconEye } from './AuthIcons';

const PasswordInput = forwardRef(function PasswordInput(
  {
    id,
    error,
    leadIcon,
    label,
    className = '',
    ...inputProps
  },
  ref
) {
  const [visible, setVisible] = useState(false);

  return (
    <div className="field">
      {label && <label htmlFor={id}>{label}</label>}
      <div className="ctrl">
        {leadIcon && <span className="lead">{leadIcon}</span>}
        <input
          {...inputProps}
          ref={ref}
          id={id}
          type={visible ? 'text' : 'password'}
          className={`inp ${leadIcon ? 'has-lead' : ''} has-trail ${error ? 'inp-error' : ''} ${className}`.trim()}
        />
        <button
          className="toggle"
          type="button"
          onClick={() => setVisible((v) => !v)}
          aria-label={visible ? 'Hide password' : 'Show password'}
        >
          <IconEye />
        </button>
      </div>
      {error && <span className="field-error">{error}</span>}
    </div>
  );
});

export default PasswordInput;
